<template>
    <div>
        <app-sub-title text="Notificaciones de alerta"></app-sub-title>
        <b-button @click="startSave" variant="primary"><i class="fa fa-plus" aria-hidden="true"></i> Crear notificación de alerta</b-button>    

        <app-alert-notifications-filters
            @filter="onFilter"
        />
        <app-alert-notifications-list :data="data"
            @change-page="changePage"
            @remove-alert="startRemove"
            @sort="onSort"
            @showAccuses="showAccuses"
        />
        <!-- Inicio pop up's -->
        <app-pop-up title="Confirmación" id="alert-notification-remove">
            <div slot="body"><h2>¿Esta seguro que desea eliminar esta notificación de alerta?</h2></div>
            <div class="buttons" slot="buttons">
                <b-button variant="primary" @click="deleteAlertNotification(selectedAlertNotification)"><i class="fa fa-trash-o"></i> Confirmar Eliminación</b-button>
            </div>
        </app-pop-up>

        <app-pop-up title="Formulario de notificación de alerta" id="alert-notification-form" :onClose="cleanForm">
            <div class="body" slot="body">
                
                <app-alert-notification-form :onSave="onSave"
                />
            </div>
            <div slot="buttons">
                <b-button variant="confirm" :disabled="inProgress" @click="$bus.$emit('alert-notification-form.save')"><i class="fa fa-floppy-o"></i> Guardar</b-button>
            </div>
        </app-pop-up>

        <app-pop-up
            size="large"
            id="accuses-window"
            title="Confirmaciones de lectura y entendimiento"
        >
            <template slot="body">
                <div>
                    <app-read-accuses :alert-notification="selectedAlertNotification"></app-read-accuses>
                </div>
            </template>
        </app-pop-up>

        <!-- fin de pop up's -->
    </div>
</template>

<script>
import AlertNotificationForm from './AlertNotificationForm/AlertNotificationForm.vue';
import AlertNotificationsFilters from './AlertNotificationsFilters/AlertNotificationsFilters.vue';
import AlertNotificationsList from './AlertNotificationsList/AlertNotificationsList.vue';
import comunicationsRepository from '../../../repositories/comunications.repository';
import ReadAccuses from './ReadAccuses/ReadAccuses';
export default {
    components: {
        appAlertNotificationForm: AlertNotificationForm,
        appAlertNotificationsFilters: AlertNotificationsFilters,
        appAlertNotificationsList: AlertNotificationsList,
        appReadAccuses: ReadAccuses
    },
    data(){
        return{
            selectedAlertNotification: '',
            filters: {},
            page: 1,
            data: {},
            sort: {
                sortBy: 'alert_notifications.created_at',
                sortDir: 'desc'
            },
            readAccuses: [],
            
        }
    },

    methods: {
        async showAccuses(alertNotification) {
            this.selectedAlertNotification = alertNotification;
            this.$bus.$emit('accuses-window.open');
        },
        loadAlertNotifications(){
            const cr = {...comunicationsRepository};
            const filters = {...this.filters, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir }; 
            cr.allAlertNotifications(filters, this.page)
                .then(data => this.data = data)
                .catch(error => toastr.error('Ocurrió un error al cargar las notificaciones de alerta'));
        },
        onFilter(filters){
            this.filters = filters;
            this.loadAlertNotifications();
        },
        changePage(page){
            this.page = page;
            this.loadAlertNotifications();
        },
        startSave(){
            this.selectedAlertNotification = '';
            this.$bus.$emit('alert-notification-form.open'); 
        },
        startRemove(alertNotification){
            this.selectedAlertNotification = alertNotification;
            this.$bus.$emit('alert-notification-remove.open');
        },
        onSave() {
            this.$bus.$emit('alert-notification-form.close');
            this.loadAlertNotifications();
        },      
        cleanForm() {
            this.$bus.$emit('alert-notification-form.clean');
        },
        deleteAlertNotification(alert){
            const cr = {...comunicationsRepository};
                cr
                .deleteAlert(alert.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.loadAlertNotifications();
                        this.$bus.$emit('alert-notification-remove.close');
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error('No se pudo borrar la notificación de alerta');
                });
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadAlertNotifications();
        }
    },
    created(){
        this.loadAlertNotifications();
    }
}
</script>

<style>

</style>
